export const REDUCER_NAME = 'search'




// WEBPACK FOOTER //
// ./src/modules/store/state/search/const.js